/** Dependencies */
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Divider, Grid, Paper, Button } from '@mui/material';

/** Components */
import UnPaidOrders from './Components/UnPaidOrders';
import PaidOrders from './Components/PaidOrders';
import SelectedOrders from './Components/SelectedOrders';

/** Types */
import { BasketProduct } from '../../../../../../models/Product';

/** Styles */
import styles from '../styles';

/** Helpers */
import { priceFormatter } from '../../../../../../helpers/moneyFormatter';

interface Props {
  list: BasketProduct[];
  handleAddPieceOrderClick: (
    id: string,
    itemTotalQuantity: number,
    itemId?: string,
  ) => void;
  handleDecreasePieceOrderClick: (id: string) => void;
  pieceValue: string;
  currencyCode: string;
}

function PaymentModalLeftSide({
  list,
  handleAddPieceOrderClick,
  handleDecreasePieceOrderClick,
  pieceValue,
  currencyCode,
}: Props) {
  const { t } = useTranslation('pos');

  const selectAllUnpaidItems = () => {
    // Tüm ödenmemiş öğeleri seçme
    list.forEach(item => {
      // Kalan ödenmeyen miktarı hesapla
      const remainingUnpaid = item.count - (item.paid_quantity || 0);

      if (
        remainingUnpaid > 0 &&
        (!item.selected_piece_orders ||
          item.selected_piece_orders.quantity === 0)
      ) {
        // Her bir ödenmemiş öğe için döngü
        for (let i = 0; i < remainingUnpaid; i++) {
          handleAddPieceOrderClick(item.id, remainingUnpaid);
        }
      }
    });
  };

  return (
    <Paper
      style={{ overflow: 'auto' }}
      sx={styles.paymentModalPaper}
      elevation={3}
    >
      <Grid container justifyContent="space-between">
        <Grid> {t('paymentModal.installment')}</Grid>
        <Grid>{priceFormatter(Number(pieceValue), currencyCode)}</Grid>
      </Grid>
      <Divider />
      <br />

      <UnPaidOrders
        list={list}
        handleAddPieceOrderClick={handleAddPieceOrderClick}
        handleDecreasePieceOrderClick={handleDecreasePieceOrderClick}
        currencyCode={currencyCode}
      />
      <PaidOrders list={list} currencyCode={currencyCode} />
      <SelectedOrders list={list} currencyCode={currencyCode} />
      <Grid container justifyContent="flex-end" sx={{ mb: 2 }}>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={selectAllUnpaidItems}
        >
          Tümünü Seç
        </Button>
      </Grid>
    </Paper>
  );
}

export default PaymentModalLeftSide;
